module.exports = __webpack_public_path__ + "img/best-service.8d905d94.jpg";